<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M5.00015 10C5.00015 8.15414 5.46094 6.95343 6.20726 6.20711C6.95358 5.46079 8.1543 5 10.0002 5C10.5524 5 11.0002 4.55228 11.0002 4C11.0002 3.44772 10.5524 3 10.0002 3C7.84601 3 6.04673 3.53921 4.79305 4.79289C3.53937 6.04657 3.00015 7.84586 3.00015 10C3.00015 10.5523 3.44787 11 4.00015 11C4.55244 11 5.00015 10.5523 5.00015 10Z" fill="currentColor" />
        <path d="M21.0002 14C21.0002 13.4477 20.5524 13 20.0002 13C19.4479 13 19.0002 13.4477 19.0002 14C19.0002 15.8459 18.5394 17.0466 17.793 17.7929C17.0467 18.5392 15.846 19 14.0002 19C13.4479 19 13.0002 19.4477 13.0002 20C13.0002 20.5523 13.4479 21 14.0002 21C16.1543 21 17.9536 20.4608 19.2073 19.2071C20.4609 17.9534 21.0002 16.1541 21.0002 14Z" fill="currentColor" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.00015 14C3.00015 12.8954 3.89558 12 5.00015 12H10.0002C11.1047 12 12.0002 12.8954 12.0002 14V19C12.0002 20.1046 11.1047 21 10.0002 21H5.00015C3.89558 21 3.00015 20.1046 3.00015 19V14ZM10.0002 14H5.00015V19H10.0002V14Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.5002 3C14.0149 3 12.0002 5.01472 12.0002 7.5C12.0002 9.98528 14.0149 12 16.5002 12C18.9854 12 21.0002 9.98528 21.0002 7.5C21.0002 5.01472 18.9854 3 16.5002 3ZM14.0002 7.5C14.0002 6.11929 15.1194 5 16.5002 5C17.8809 5 19.0002 6.11929 19.0002 7.5C19.0002 8.88071 17.8809 10 16.5002 10C15.1194 10 14.0002 8.88071 14.0002 7.5Z"
            fill="currentColor"
        />
    </svg>
</template>
